import { TRACKERS } from "@/constants/Trackers";
import { MedicationsAllergies } from "@/features/Patient/MedicalRecords/MedicationsAllergies/MedicationsAllergies";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/patient/$patientId/medications-allergies",
)({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_MEDICATIONS);
  },
});

function RouteComponent() {
  return <MedicationsAllergies />;
}
